import React from 'react';
import '../template-file-css/document-file-template.css';


export const OTP_OrderForServices = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='OTP_OrderForServices' className='file-pdf-document'>
            <div className='file-template'>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Services Recommended</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cb_1' name='cb_1' className='add-only' value='1' /> Community Support Individual
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cb_2' name='cb_2' className='add-only' value='1' /> Family Outpatient Services: Family Counseling / Family Training
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cb_3' name='cb_3' className='add-only' value='1' /> Behavioral Health Assessment & Service Plan Development
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cb_4' name='cb_4' className='add-only' value='1' /> Crisis Intervention
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cb_5' name='cb_5' className='add-only' value='1' /> Group Outpatient Services: Group Counseling / Group Training
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cb_6' name='cb_6' className='add-only' value='1' /> Individual Counseling
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cb_7' name='cb_7' className='add-only' value='1' /> Psychological Testing
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cb_8' name='cb_8' className='add-only' value='1' /> Diagnostic Assessment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cb_9' name='cb_9' className='add-only' value='1' /> Medication Administration
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cb_10' name='cb_10' className='add-only' value='1' /> Nursing Assessment & Health Services
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cb_11' name='cb_11' className='add-only' value='1' /> Psychiatric Treatment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cb_12' name='cb_12' className='add-only' value='1' /> Intensive Family Intervention
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='signature w-570'></td>
                        <td className='signature w-150'></td>
                    </tr>
                    <tr>
                        <td className='small w-570'>Printed Name</td>
                        <td className='small w-150'>Credentials</td>
                    </tr>
                    <tr>
                        <td className='signature w-570'></td>
                        <td className='signature w-150'></td>
                    </tr>
                    <tr>
                        <td className='small w-570'>Signature</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                </table>


            </div>
        </form>

    )
}  
